const railsEnv = process.env.RAILS_ENV
const googleAnalyticsId = document.head.querySelector("meta[name='google-analytics-id']")?.content

window.dataLayer = window.dataLayer || []
function gtag() { dataLayer.push(arguments) }
gtag('js', new Date())

if (!!railsEnv && railsEnv === 'production' && !!googleAnalyticsId) {
  document.addEventListener('turbo:load', function(event) {
    gtag('config', googleAnalyticsId, { page_location: event.detail.url })
  })
}

export default gtag
